import React from 'react'
import AppKarmaIcon from '../Icons/AppIcons/AppKarmaIcon.svg'
import CashKarmaIcon from '../Icons/AppIcons/CashKarmaIcon.svg'
import LandingLeftImage from '../Images/MomoKarmaImages/LandingRightImage.svg'
import LandingRightBg from '../Images/MomoKarmaImages/LandingRightBg.svg'
import LandingThreePoints from '../Images/MomoKarmaImages/LandingThreePoints.svg'
import DividerIcon from "../Images/MomoKarmaImages/DividerIcon.svg"
import { Image } from '@nextui-org/react'

export default function Landing({ landingRef }) {
  const content = {
    title: (
      <div className="xl:text-7xl lg:text-6xl text-5xl tracking-normal font-bold">
        <div className="flex">
          <div className="pt-6">WE MAKE</div>
          <div className="pl-2">
            <Image
              src={LandingThreePoints}
              alt={'line'}
              width={'60'}
              height={'55'}
            />
          </div>
        </div>
        <div className="mt-1 font-mulish">
          <div className="flex lg:items-center md:flex-row flex-col">
            <span className="text-[#147AFF]">REWARDS</span>
            <span className="md:ps-2">APPS</span>
          </div>
        </div>
      </div>
    ),
    leftSide: (
      <div className="lg:pt-2 pt-0">
        <div>
          <p className="text-wrap xl:text-lg">
            10+ years, millions in payouts, and a global community that loves getting rewarded — we've made earning fun.
          </p>
        </div>
        <div className="lg:mt-7 mt-3 flex gap-4">
          <div className="flex items-center gap-1">
            <Image
              src={AppKarmaIcon}
              alt="AppKarmaIcon"
              width={'40'}
              height={'40'}
            />
            AppKarma
          </div>
          <div className="lg:flex hidden items-center">
            <Image
              src={DividerIcon}
              alt="Divider logo"
              width={'4'}
              height={'4'}
            />
          </div>
          <div className="flex items-center gap-2">
            <Image
              src={CashKarmaIcon}
              alt="AppKarmaIcon"
              width={'40'}
              height={'40'}
            />
            CashKarma
          </div>
        </div>
      </div>
    ),
    rightSide: (
      <Image
        src={LandingLeftImage}
        alt="Landing Image"
        width={'624'}
        height={'624'}
      />
    ),
  }

  return (
    <div
      ref={landingRef}
      id="landing_page"
      className="lg:px-10 px-2 lg:pt-0 pt-36 h-screen bg-white-400 flex flex-col justify-center md:flex-row lg:container mx-auto snap-start w-screen h-screen"
    >
      <div 
        className="md:w-1/2 flex items-center justify-center p-4"
        style={{
          backgroundImage: `url(${LandingRightBg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className="w-full">
          <div>{content.title}</div>
          <div className="mg:mt-4 mt-2">{content.leftSide}</div>
        </div>
      </div>
      <div className="md:w-1/2 flex items-center justify-center p-4">
        <div>
          {content.rightSide}
        </div>
      </div>
    </div>
  )
}
